define('modules/editor/views/correodirect_forms_itemview',['require','exports','module','backbone','underscore','base/collectionview','../../form_editor/collections/fields','./correodirect_fields_itemview'],function(require, exports, module) {
  "use strict";

  var Backbone = require("backbone"),
      _ = require("underscore"),
      CollectionView = require("base/collectionview"),
      FieldCollection = require("../../form_editor/collections/fields"),
      Field = require("./correodirect_fields_itemview");

  module.exports = CollectionView.extend({
    className: "js-form-fields",
    itemView: Field,
    initialize: function(options) {
      this.collection = options.model.fields;
    },
    collectionIterator: function(collection, fn, ctx) {
      var integrableFields = collection.filter(function(item){
        return item.isIntegrable;
      });
      _.each(integrableFields, fn, ctx);
    }
  });

});

